
namespace Gamification.Gamification {
    export class AziendeColumns {
        static columnsKey = 'Gamification.Aziende';
    }
}